<div class="grid ">
    <div class="col-12">
        <div class="card">
            <h4>Detalhar Vinculo Usuário</h4>
            <form #form="ngForm" name="form" novalidate>
                <div class="formgroup" *ngIf="usuario">
                    <div class="p-fluid p-formgrid grid">
                        <div class="field col-12 md:col-12">
                            <p-divider></p-divider>
                        </div>
                        <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                            <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label htmlFor="nome">Nome</label>
							<label class="form-control" >{{ usuario.nome }}</label>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label htmlFor="email">E-mail</label>
                            <label class="form-control" >{{ usuario.email }}</label>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label htmlFor="cpf">CPF</label>
                            <label class="form-control" >{{ usuario.cpf | cpfFormat }}</label>
                        </div>
                        <div class="field col-12 md:col-12">
                            <p-divider></p-divider>
                        </div>
                        
                        <div class="col-12 md:col-10">
                        </div>

                        <div class="col-12 md:col-12">
                            <h5>Permissões Adicionadas</h5>
                            <div class="flex justify-content-center" *ngIf="exibirSpinnerTree">
                                <p-progressSpinner></p-progressSpinner>
                            </div>
                            <div class="col-12 md:col-12" *ngIf="!exibirSpinnerTree">
                                <p-treeTable [value]="categoriasTreeTableSalvas" [columns]="colunasTreeTableSalvas"
                                    >
                                    
                                    <ng-template pTemplate="header" let-columns>
                                        <tr>
                                            <th *ngFor="let col of columns">
                                                {{col.header}}
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
                                        <tr>
                                            <td *ngFor="let col of columns; let i = index">
                                                <p-treeTableToggler [rowNode]="rowNode" *ngIf="i == 0"></p-treeTableToggler>
                                                {{rowData[col.field]}}
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-treeTable>
                            </div>

                        </div>
                        
                       
                        

                    </div>
                    <div class="p-fluid p-formgrid grid justify-content-end">
                        <div class="field col-12 md:col-2">
                            <button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
                                class="p-button-primary mt-5" (click)="voltar()"></button>
                        </div>
                    </div>
                </div>
            </form>
            
        </div>
    </div>
</div>